export default __webpack_public_path__ + "static/media/flop-types_0001_thumb.a5704762.jpg";